module.exports = __webpack_public_path__ + "img/gun-slash.bf0f4d28.svg";